import KitchenDisplay from 'src/models/kitchen-display/KitchenDisplay'
import Model, { encoders, ID } from 'src/models/model'

export default class KdsClient extends Model {
  static name = 'KdsClient'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      kitchenDisplay: {
        type: KitchenDisplay,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },
      isElectronMode: {
        type: Boolean
      }
    }

    this.queries = {
      currentKdsClient: {
        results: {
          kdsClient: KdsClient
        }
      }
    }
  }
}
